// Meta currency offsets (not ISO decimal digits):
// https://developers.facebook.com/docs/marketing-api/currencies/
const WHOLE_UNIT_CURRENCIES = new Set(['CLP', 'COP', 'CRC', 'HUF', 'ISK', 'IDR', 'JPY', 'KRW', 'PYG', 'TWD', 'VND']);

export function budgetOffset(currency: string): number {
  return WHOLE_UNIT_CURRENCIES.has(currency.trim().toUpperCase()) ? 1 : 100;
}

export function quoteBudget(usd: number, rate: number, offset: number) {
  if (!Number.isFinite(usd) || usd <= 0 || !Number.isFinite(rate) || rate <= 0 || ![1, 100].includes(offset)) {
    throw new Error('Некоректний бюджет або курс валюти');
  }
  const apiAmount = Math.round(usd / rate * offset);
  if (!Number.isSafeInteger(apiAmount) || apiAmount <= 0) {
    throw new Error('Бюджет замалий або перевищує допустиме значення');
  }
  return { apiAmount, nativeAmount: apiAmount / offset, usdAmount: apiAmount / offset * rate };
}

// Existing sync and database rows use Meta's raw integer / 100 for EVERY
// currency. Preserve that storage contract so historical CLP rows need no migration.
export function storedBudgetToUsd(stored: number, rate: number, offset: number): number {
  return stored * 100 / offset * rate;
}
